function main() {
 $(function () {
  $("#root").css("zoom", "normal");
  let scale = document.body.clientWidth / 1080;
  $("#root").css("zoom", scale);

  window.addEventListener(
   "resize",
   (function () {
    var timer;
    return function () {
     if (timer) clearTimeout(timer);
     timer = setTimeout(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);
     }, 100);
    };
   })()
  );
 });

 function lazyLoadImages() {
  const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
  const config = {
   rootMargin: "0px 0px 300px 0px",
   threshold: 0,
  };

  const lazyLoadObserver = new IntersectionObserver(function (
   entries,
   observer
  ) {
   entries.forEach(function (entry) {
    if (entry.isIntersecting) {
     // 当图片进入视口时
     const image = entry.target;
     const dataSrc = image.getAttribute("data-src");
     image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
     lazyLoadObserver.unobserve(image); // 停止观察该图片
    }
   });
  },
  config);

  images.forEach(function (image) {
   lazyLoadObserver.observe(image); // 开始观察每个图片
  });
 }

 document.addEventListener("DOMContentLoaded", function () {
  lazyLoadImages();

  // 找到所有的锚点链接
  var links = document.querySelectorAll('a[href^="#shopping"]');
  // 为每个链接添加点击事件
  links.forEach(function (link) {
   link.addEventListener("click", function (event) {
    event.preventDefault(); // 阻止默认的跳转行为

    // 找到目标锚点元素
    var targetElement = document.getElementById("shopping");

    // 如果目标元素存在，则滚动到该元素位置
    if (targetElement) {
     targetElement.scrollIntoView({ behavior: "smooth" });
    }
   });
  });
 });

 // IOS字体多了间距的处理 给节点添加 sp_system 类名
 // 判断当前用户是安卓端还是iOS端
 var userAgent = navigator.userAgent || navigator.vendor || window.opera;
 var isAndroid = /android/i.test(userAgent);
 var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
 var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

 if (isAndroid) {
  console.log("Android");
 } else if (isIOS) {
  console.log("iOS");
 } else if (isPC) {
  console.log("PC");
 } else {
  $(".sp_system").css("letter-spacing", "-4px");
 }
 var swiper = new Swiper(".mySwiper", {
  spaceBetween: 30,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,
  navigation: {
   nextEl: ".next.swiper-button-next",
   prevEl: ".prev.swiper-button-prev",
   disabledClass: "button",
  },
 });
 $(".prev").click(function () {
  swiper2.slidePrev();
 });
 $(".next").click(function () {
  swiper2.slideNext();
 });
 var swiper2 = new Swiper(".mySwiper2", {
  thumbs: {
   swiper: swiper,
  },
  autoplay: true,
  autoplay: {
   disableOnInteraction: false,
  },
  loop: true,
 });

 var swiper3 = new Swiper(".mySwiper3", {
  autoplay: true,
  autoplay: {
   disableOnInteraction: false,
  },
  loop: true,
  pagination: {
   el: ".swiper-pagination",
   clickable: true,
  },
 });

 var swiper4 = new Swiper(".mySwiper4", {
  slidesPerView: 1.3,
  spaceBetween: 30,
  centeredSlides: true,
  loop: true,
  autoplay: {
   delay: 1000,
   stopOnLastSlide: false,
   disableOnInteraction: false,
  },
 });
  var swiper5 = new Swiper("#swiper_box", {
        autoplay: true,
        autoplay: {
          disableOnInteraction: false,
        },
        loop: true,
        spaceBetween: 30,
        pagination: {
          el: ".pagination2",
          type: "bullets",
          clickable: true,
        },
      });

 new Swiper("#swiper2", {
  loop: true,
  centeredSlides: true,
  spaceBetween: 10,
  slidesPerView: 1.2,
  freeMode: true,
  speed: 7000, //匀速时间
  autoplay: {
   delay: 0,
   stopOnLastSlide: false,
   disableOnInteraction: false,
  },
 });

  let prods = window.product
  console.log('prods', prods)
  function getCur(){
          let color = $('#color div.active').attr('data-val')
          let Size = $('#Size div.active').attr('data-val')
          return prods.filter(item=> item.option1 == color && item.option2 == Size)[0]
        }
        function changePrice(){
          let num = $('#calcNumber').val()
          let price = (getCur().price * num / 100).toFixed(2)
          let compare = (getCur().compare_at_price * num / 100).toFixed(2)
          // if(num == 1){
          //   price = (getCur().price * num / 100).toFixed(2)
          // }else if(num == 2){
          //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
          // }else if(num == 3){
          //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
          // }else {
          //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
          // }
          price = (price + '').replace('.', ',')
          compare = (compare + '').replace('.', ',')
          $('.product-infos .price-group .price1 span').html(price)
          $('.product-infos .price-group .price2 span').html(compare)
          let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
          $(".product-infos .sp-offs span").html(off_font);
        }

  $('.buyNow').click(function(){
          let num = $('#calcNumber').val()
          window.location.href = '/cart/' + getCur().id + ':' + num
        })

 $(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
   input.value = num;
  }
   changePrice()
 });
 $(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
   changePrice()
 });

 $(".size-wrap").click(function () {
  $(".mask").css("display", "flex");
  $(".mask .size-pop").css("display", "block");
  $(".mask .img-pop").css("display", "none");
 });

 $(".sp-large").click(function () {
  $(".mask").css("display", "flex");
  $(".mask .img-pop .sp-img")[0].src = $(".img-wrap>img")[0].src;
  $(".mask .img-pop").css("display", "block");
  $(".mask .size-pop").css("display", "none");
 });
 $(".close-btn").click(function () {
  $(".mask").hide();
 });
 $(".close-pop").click(function () {
  $(".mask").hide();
 });

 $(".mask").click(function (e) {
  if ($(e.target).closest(".mask .btn").length > 0) {
  } else {
   // $(".mask").hide();
  }
 });
 // 滚动隐藏
 $(function () {
  $(".option").click(function () {
   $(this).siblings().removeClass("active");
   $(this).addClass("active");
    changePrice()
  });

  // style选项
  let typeOptions = $("#color .option");
  let img0 = $(".p-img");

  // 切换选项
  function checkType(index) {
   $(".img-wrap>img").attr("src", "https://cdn.shopifycdn.net/s/files/1/0665/8470/7318/files/img-" + index + ".png");
  }

  typeOptions.click(function () {
   let index = $(this).index();
   checkType(index);
  });

  // style选项
  $(".cart-btn").click(function () {
   $(this).children("img").addClass("on");
   setTimeout(function () {
    $(".cart-btn").children("img").removeClass("on");
   }, 500);
   $(".sp-header-top .sp-cart").addClass("on");
   setTimeout(function () {
    $(".sp-header-top .sp-cart").removeClass("on");
   }, 500);
  });
  
  $(".product-part .cart-btn").click(function () {
    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });

   var img = $(this).parents(".product-part").find(".img-wrap").children("img");

   var flyer = img[0].cloneNode(true);
   flyer.classList.add("sp_clone");

   $(".product-part").append(flyer);
   $(".sp_clone").css({
    width: img[0].width,
    height: img[0].height,
    position: "fixed",
    top: 0,
    left: img.offset().left,
    "z-index": "99",
   });

   let finish = $(".sp-cart");
   $(".sp_clone").animate(
    {
     top: finish[0].offsetTop + $(".sp-nav-top").height(),
     left: finish[0].offsetLeft + finish.width() / 2,
     width: 50, // 结束时的大小，根据需要调整
     height: 50, // 结束时的大小，根据需要调整
     opacity: 0.4,
     "z-index": "99",
    },
    500,
    "linear",
    function () {
     $(this).animate(
      {
       width: 0,
       height: 0,
       opacity: 0,
      },
      0,
      function () {
       $(".sp-header-top .sp-cart").addClass("sp-shake");
       setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("sp-shake");
       }, 400);
       $(this).detach();
      }
     );
    }
   );
   $(".alert").show(300).delay(2000).hide(300);
  });
 });


  
}

main();
